export default __webpack_public_path__ + "static/media/goiCuocHeadHot.3ff90c69.svg";